import React from 'react';
import PropTypes from 'prop-types';

const ShowAllTable = (props) => {
  let colContent = [];
  for(let i=0; i < props.numberOfColumns; i++){
    colContent.push(<col key={i}/>);
  }

  return (
    <div className="calc-setting-table">
      <table className="table">
        <colgroup>
          {colContent}
        </colgroup>
        <tbody>
        <tr>
          <td className="text-center" colSpan={props.numberOfColumns.toString()}>
            {!props.showAll && <a onClick={()=>props.handleShowHideClick(true)}>Sýna alla töflu</a> }
            {props.showAll && <a onClick={()=>props.handleShowHideClick(false)}>Fela</a>}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  );
};

ShowAllTable.propTypes = {
  showAll: PropTypes.bool.isRequired,
  handleShowHideClick : PropTypes.func.isRequired,
  numberOfColumns : PropTypes.number.isRequired
};

export default ShowAllTable;




// WEBPACK FOOTER //
// ./src/pages/Calculation/Settings/ShowAllTable.js